<section class="card">
    <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-0">
        <div class="flex flex-column text-center md:text-left">
            <span class="text-700 text-2xl mb-2 font-bold">SOLICITUD #{{ currentProject()?.numeroExpediente }}</span>
            <span class="text-700 text-lg">{{ currentProject()?.descripcion }}</span>
        </div>
        <div class="p-toolbar-group-end">
            <span class="p-2">
                <p-button (click)="goBack()" label="Regresar" icon="pi pi-undo text-2xl"
                    styleClass="p-button-rounded ml-2" />
            </span>
        </div>
    </div>
</section>

<iframe class="card p-0" [src]="mnrSystemUrl()" frameborder="0"
    sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox">
</iframe>


<div class="p-fluid p-formgrid grid mt-2">
    <div class="field col-12 md:col-9">
        <ul class="list-none m-0 w-full">
            <li class="flex justify-content-between surface-border py-3">
                <span class="text-900 text-4xl font-medium">Total a cancelar por trámite: $ <b>{{ tarifa }}</b>
                </span>
            </li>
        </ul>
    </div>
    <div class="field col-12 md:col-3">
        <div class="flex justify-content-end gap-2">
            <p-button class="ml-3" icon="pi pi-calculator"
            styleClass="p-button-icon p-button-info p-button-lg p-button-rounded w-full h-full" (click)="onChangeCalcularTarifa()"
                pTooltip="Calcular tarifa" tooltipPosition="top"></p-button>
            <p-button (click)="completarTramite()" label="Proceder a pagar"
            icon="pi pi pi-cart-plus"
            iconPos="right"
            [rounded]="true"
            styleClass="p-button-icon p-button-info text-xl h-full" [disabled]="isLoading()"></p-button>
        </div>
    </div>
</div>
<div class="p-fluid grid" *ngIf="tramiteService.textTarifa!=''">
    <div class="col-12 align-self-center">
        <small class="text-gray-600">*{{ tramiteService.textTarifa }}</small>
    </div>
</div>
